<header class="d-flex w-100 align-items-center">
    <a [routerLink]="['/']">
        <img src="assets/image/logo.svg" alt="Brand Logo">
    </a>
    <div class="d-flex flex-grow-1 justify-content-end align-items-center" *ngIf="sessionSrv.isAuthenticated">
        <div class="info d-flex flex-column" *ngIf="showUserData">
            <div class="user-name">{{sessionSrv.session ? sessionSrv.session['name'] : ''}}</div>
            <div class="user-activity">Letzte Anmeldung : {{sessionSrv.session ? sessionSrv.session['last_login_date'] : ''}} </div>
            <div class="app-version">Version 2.0</div>
        </div>
        <flow-impersonate *ngIf="showImpoeonate"></flow-impersonate>
        <flow-demo-roles *ngIf="showDemoRoles"></flow-demo-roles>
        <flow-notification></flow-notification>
        <button *ngIf="sessionRenew" (click)="renew()" class="btn btn-renew" >
            <span class="d-none d-md-inline">Erneuern</span>
        </button>
        <button (click)="signOut()" class="btn btn-signout" >
            <span class="d-none d-md-inline">Abmelden</span>
        </button>
        <!-- <a [routerLink]="['/profile']" class="d-flex align-items-center link link-profile">
            <i class="fa fa-user-circle-o" aria-hidden="true"></i>
        </a> -->
        
    </div>
</header>